<template>
    <div id="rightPopup">
      <extralable v-if="false"></extralable>
      <callCenter v-if="$store.getters.isPC"></callCenter>
      <div v-if="$route.path !=='/application' && $route.path !=='/submit_success'" class="application" @click="goApplication">
        <div class="icon-call"></div>
        <div class="popText">合作申请</div>
      </div>
    </div>
</template>
<script>
import callCenter from '@/components/callcenter'
import extralable from '@/components/extralable'
export default {
  data () {
    return {}
  },
  components: { callCenter, extralable },
  methods: {
    goApplication () {
      this.$router.push('/application')
      !this.$store.getters.isPC && this.$root.$emit('bv::toggle::collapse', 'nav_collapse')
    }
  }
}
</script>
<style lang="scss" scoped>
@include isPC() {
  #rightPopup {
  position: fixed;
  right: 0px;
  top: 60%;
  transition: all ease 500ms;
  z-index: 100;
  transform: translateY(-50%);
  .application{
    background-color: #fff;
    width: 38px;
    height: 95px;
    padding: 12px 11px 12px 12px;
    border-radius: 4px;
    border: 0;
    margin-top: 1px;
    cursor: pointer;
    z-index: 100;
    transition: all 300ms ease;
    box-shadow:0px 8px 32px 0px rgba(238,238,238,0.6);
    .icon-call{
      width: 15px;
      height: 14px;
      background: url('https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/icon-application.png') no-repeat center;
      background-size: 100% 100%;
    }
    .popText {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #5B83F0;
      text-align: center;
      border-radius: 20px;
      white-space: normal;
      line-height: 12px;
      margin-top: 7px;
    }
    &:hover{
      color: #fff;
      background: #5C84F0;
      .popText{
        color: #fff;
      }
      .icon-call{
        background: url('https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/icon-application-select.png') no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
}
}
@include isMobile() {
  #rightPopup {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    z-index: 100;
    .application{
      height: rem(87);
      line-height: rem(87);
      width: 100%;
      color: #fff;
      background: #FF6D00;
      padding: 0;
      border: 0;
      border-radius: 0;
      top: auto;
      transform: none;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 100;
      .icon-call{
        width: rem(37);
        height: rem(45);
        background: url('https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/icon-call-m.png') no-repeat center;
        display: inline-block;
        background-size: 100% 100%;
      }
      .popText {
        display: inline-block;
        font-size: rem(30);
        font-weight: 500;
        width: rem(180);
        position: relative;
        margin-left: rem(23);
        top: 0;
      }
    }
  }
}
</style>
